import { bgPrimary } from '@osmosis/tailwind-ui/styles/background';
import { textGrayInvert } from '@osmosis/tailwind-ui/styles/text';
import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';

import { FormattedMessage } from 'react-intl';

import { CLOUDFRONT_ASSET_URL } from '@osmosis/constants';
import Image from 'next/image';

/**
 *.
 */
const PlaylistHeader = (): JSX.Element => {
  return (
    <Box className={`w-[100%] ${bgPrimary} p-8`}>
      <Flex className={`items-center max-w-[1600px] m-[auto] relative`}>
        <Flex className={`mr-4`}>
          <Image
            src={`${CLOUDFRONT_ASSET_URL}WcQcH_1BQJqvx5Qxkqb2y4BCQ7yaK7cm.svg`}
            alt=""
            width={55}
            height={55}
          />
        </Flex>
        <Flex data-testid="playlists-header-label" className={`items-center`}>
          <H1 className={`${textGrayInvert} mr-4`}>
            <FormattedMessage
              id="playlist.heading.playlistHeading"
              defaultMessage="Playlists"
            />
          </H1>
        </Flex>
      </Flex>
    </Box>
  );
};

export default PlaylistHeader;
